// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-overview {
  padding: 24px;
}

.service-overview .ant-card {
  margin-bottom: 24px;
}

.service-detail {
  padding: 24px;
}

.service-detail .ant-card {
  margin-bottom: 16px;
}

.service-detail .ant-tabs-nav {
  margin-bottom: 16px;
}

.service-detail .ant-form-item {
  margin-bottom: 16px;
}

/* 自定义抽屉样式 */
.history-drawer .ant-timeline {
  padding: 16px;
}

.history-drawer .ant-timeline-item {
  padding-bottom: 20px;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
  .service-overview,
  .service-detail {
    padding: 12px;
  }
}

.service-detail .basic-info-card {
  margin-bottom: 24px;
}

.service-detail .detail-tabs-card {
  margin-top: 24px;
}

.service-detail .ant-card-head {
  border-bottom: none;
}

/* Region configuration styles */
.region-table .ant-table-expanded-row .ant-table-wrapper {
  margin: 0;
}

.region-table .ant-table-expanded-row .ant-table-cell {
  padding: 8px 16px;
}

.region-table .ant-table-row-expand-icon-cell {
  width: 48px;
}

.region-table .ant-table-expanded-row > td {
  background-color: #fafafa;
}

.region-table .ant-tag {
  margin-right: 0;
}

.basic-info {
  background: #fff;
  padding: 24px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 32px;
}

.info-row {
  display: flex;
  line-height: 32px;
  min-width: 0;
}

.info-label {
  width: 100px;
  flex-shrink: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.info-value {
  flex: 1 1;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

/* Region overview styles */
.region-overview-card {
  margin: 24px 0;
}

.region-overview-card .geo-card {
  height: 100%;
}

.region-overview-card .geo-card .ant-card-head {
  min-height: 40px;
  padding: 0 12px;
}

.region-overview-card .geo-card .ant-card-head-title {
  padding: 8px 0;
  font-size: 14px;
}

.region-overview-card .ant-card-grid {
  box-shadow: none;
  border-bottom: 1px solid #f0f0f0;
}

.region-overview-card .ant-card-grid:last-child {
  border-bottom: none;
}

.region-overview-card .ant-statistic {
  margin-bottom: 0;
}

.region-overview-card .ant-statistic-title {
  font-size: 12px;
  margin-bottom: 4px;
}

.region-overview-card .ant-statistic-content {
  font-size: 14px;
}

.region-overview-card .ant-card-grid:hover {
  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16),
              0 3px 6px 0 rgba(0, 0, 0, 0.12),
              0 5px 12px 4px rgba(0, 0, 0, 0.09);
  cursor: pointer;
  transition: all 0.3s;
} `, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA,YAAY;AACZ;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;gDAE8C;EAC9C,eAAe;EACf,oBAAoB;AACtB","sourcesContent":[".service-overview {\n  padding: 24px;\n}\n\n.service-overview .ant-card {\n  margin-bottom: 24px;\n}\n\n.service-detail {\n  padding: 24px;\n}\n\n.service-detail .ant-card {\n  margin-bottom: 16px;\n}\n\n.service-detail .ant-tabs-nav {\n  margin-bottom: 16px;\n}\n\n.service-detail .ant-form-item {\n  margin-bottom: 16px;\n}\n\n/* 自定义抽屉样式 */\n.history-drawer .ant-timeline {\n  padding: 16px;\n}\n\n.history-drawer .ant-timeline-item {\n  padding-bottom: 20px;\n}\n\n/* 响应式布局调整 */\n@media (max-width: 768px) {\n  .service-overview,\n  .service-detail {\n    padding: 12px;\n  }\n}\n\n.service-detail .basic-info-card {\n  margin-bottom: 24px;\n}\n\n.service-detail .detail-tabs-card {\n  margin-top: 24px;\n}\n\n.service-detail .ant-card-head {\n  border-bottom: none;\n}\n\n/* Region configuration styles */\n.region-table .ant-table-expanded-row .ant-table-wrapper {\n  margin: 0;\n}\n\n.region-table .ant-table-expanded-row .ant-table-cell {\n  padding: 8px 16px;\n}\n\n.region-table .ant-table-row-expand-icon-cell {\n  width: 48px;\n}\n\n.region-table .ant-table-expanded-row > td {\n  background-color: #fafafa;\n}\n\n.region-table .ant-tag {\n  margin-right: 0;\n}\n\n.basic-info {\n  background: #fff;\n  padding: 24px;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px 32px;\n}\n\n.info-row {\n  display: flex;\n  line-height: 32px;\n  min-width: 0;\n}\n\n.info-label {\n  width: 100px;\n  flex-shrink: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n}\n\n.info-value {\n  flex: 1;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* 响应式布局 */\n@media (max-width: 768px) {\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Region overview styles */\n.region-overview-card {\n  margin: 24px 0;\n}\n\n.region-overview-card .geo-card {\n  height: 100%;\n}\n\n.region-overview-card .geo-card .ant-card-head {\n  min-height: 40px;\n  padding: 0 12px;\n}\n\n.region-overview-card .geo-card .ant-card-head-title {\n  padding: 8px 0;\n  font-size: 14px;\n}\n\n.region-overview-card .ant-card-grid {\n  box-shadow: none;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.region-overview-card .ant-card-grid:last-child {\n  border-bottom: none;\n}\n\n.region-overview-card .ant-statistic {\n  margin-bottom: 0;\n}\n\n.region-overview-card .ant-statistic-title {\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.region-overview-card .ant-statistic-content {\n  font-size: 14px;\n}\n\n.region-overview-card .ant-card-grid:hover {\n  box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16),\n              0 3px 6px 0 rgba(0, 0, 0, 0.12),\n              0 5px 12px 4px rgba(0, 0, 0, 0.09);\n  cursor: pointer;\n  transition: all 0.3s;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
